export function handleResourceTabs() {
  // Set target="_blank" for links that don't contain "/resources/"
  document.querySelectorAll('.fndry-btn-dynamicResourceButton:not([href*="/resources/"])').forEach((link) => {
    link.setAttribute("target", "_blank");
    link.setAttribute("rel", "noopener noreferrer");
  });

  // Remove target="_blank" for links that contain "/resources/"
  document.querySelectorAll('.fndry-btn-dynamicResourceButton[href*="/resources/"]').forEach((link) => {
    link.removeAttribute("target");
    link.removeAttribute("rel");
  });
}
